import { isPlainObject } from "lodash-es";
import { getDeviceId, getDecodedTime } from "./helpers";

export function getDemoEcallMessages(demoMessages) {
  if (!Array.isArray(demoMessages)) throw new Error(`Expected array of messages`);
  const ecallMessages = {};
  let total = 0;
  for (const msg of demoMessages) {
    const { payload } = msg;
    if (!isPlainObject(payload) || !isPlainObject(payload.value)) continue;
    const deviceId = msg.deviceId || getDeviceId(payload);
    if (!deviceId) continue;
    if (msg.name && msg.name.startsWith('ecall')) {
      const ecallMeta = { ...payload };
      ecallMeta.time = getDecodedTime(msg);
      ecallMeta.sender = msg.direction === 'UPLINK'
        ? msg.deviceId
        : (payload.source || 'PSAP');
      if (!(deviceId in ecallMessages)) {
        ecallMessages[deviceId] = [];
      }
      ecallMessages[deviceId].push(ecallMeta);
      total++;
    }
  }
  for (const deviceId in ecallMessages) {
    ecallMessages[deviceId].sort((a, b) => a.time.localeCompare(b.time));
  }
  return { ecallMessages, total };
}
